<template>
  <v-card>
    <div class="transaction-confirm-card">
      <div class="modal-title">
        {{ $t("dialogs.transactionConfirm.continueInWallet") }}
      </div>
      <div class="mt-2 d-flex ga-1 align-center justify-end">
        <v-btn
          variant="text"
          size="large"
          color="rgba(255, 255, 255, 0.5)"
          class="text-uppercase"
          @click="modalData.reject && modalData.reject()"
        >
          <span v-text="$t('common.cancel')" />
        </v-btn>
        <v-btn
          color="primary"
          size="large"
          @click="modalData.confirm && modalData.confirm()"
        >
          <span v-text="$t('common.confirm')" />
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useTransactionConfirmModal } from "@/stores/transactionConfirmModal";

const { modalData } = storeToRefs(useTransactionConfirmModal());
</script>

<style lang="scss" scoped>
.transaction-confirm-card {
  position: relative;
  max-width: 460px;
  background: #1a1a1a;
  border: 1px solid #232323;
  border-radius: 10px;
  padding: 17px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 15px;
  isolation: isolate;

  > .v-card-text,
  > .v-card-actions {
    padding: 0 !important;
  }
}

.modal-title {
  width: 100%;
  font-weight: 600;
  font-size: 18px;
  line-height: 13px;
  letter-spacing: 0.04em;
  color: #ffffff;
}

.highlight-token {
  margin-left: 5px;
  font-weight: 600;
  color: #ffffff;
}

.token-box-group {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.token-box {
  position: relative;
  width: 100%;
  height: 52px;
  border: 1px solid #373737;
  border-radius: 4px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #1a1a1a;
}

.token-box-value {
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: #ffffff;
}

.token-box-symbol {
  font-weight: 700;
  font-size: 14px;
  line-height: 10px;
  letter-spacing: -0.12em;
  text-transform: uppercase;
  color: #ffffff;
}

.middle-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid #373737;
  background: #1a1a1a;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .arrow-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    background: #2d2d2d;
    border: 1px solid #373737;
  }
}

.estimated-text {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.04em;
  color: #ffffff;
}

.order-details-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 13px;
  color: #ffffff;
}

.details-list {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
}
</style>
